import * as Sentry from '@sentry/react'
import {tanstackRouterBrowserTracingIntegration} from '@sentry/react'
import type {RegisteredRouter} from '@tanstack/react-router'

import {getFeedbackIntegrationOptions} from './sentry/feedback-integration-options'

export function initSentry(router: RegisteredRouter) {
    const dsn = import.meta.env.VITE_SENTRY_DSN
    if (!import.meta.env.PROD || !dsn) {
        return
    }

    Sentry.init({
        dsn,
        environment: import.meta.env.MODE,
        release: import.meta.env.VITE_SENTRY_RELEASE || undefined,
        sendDefaultPii: false,
        integrations: [
            tanstackRouterBrowserTracingIntegration(router),
            Sentry.consoleLoggingIntegration({levels: ['warn', 'error']}),
            Sentry.replayIntegration({
                maskAllText: false,
                maskAllInputs: false,
            }),
            Sentry.feedbackIntegration(getFeedbackIntegrationOptions()),
        ],
        tracesSampleRate: 1.0,
        tracePropagationTargets: [/^\/api/],
        enableLogs: true,
        replaysOnErrorSampleRate: 1.0,
        replaysSessionSampleRate: 0.0,
    })
}
